// Import model
import { FilterOtgVinylCatalogStyleRequest } from '../models/FilterOtgVinylCatalogStyleRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgVinylCatalogStyleCondition } from '../models/OtgVinylCatalogStyleCondition';
import { OtgVinylCatalogStyleFields } from '../models/OtgVinylCatalogStyleFields';
import { OtgVinylCatalogStyleIndexedFields } from '../models/OtgVinylCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { OtgVinylCatalogStyleConditionSerializer } from './OtgVinylCatalogStyleConditionSerializer';
import { OtgVinylCatalogStyleFieldsSerializer } from './OtgVinylCatalogStyleFieldsSerializer';
import { OtgVinylCatalogStyleIndexedFieldsSerializer } from './OtgVinylCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgVinylCatalogStyleRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgVinylCatalogStyleRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgVinylCatalogStyleRequest instance
   */
  static deserialize(json: string): FilterOtgVinylCatalogStyleRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgVinylCatalogStyleRequest instance
   */
  static fromObject(obj: any): FilterOtgVinylCatalogStyleRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgVinylCatalogStyleRequest');
    }


    const instance: FilterOtgVinylCatalogStyleRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgVinylCatalogStyleIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgVinylCatalogStyleFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgVinylCatalogStyleConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgVinylCatalogStyleRequest instances
   */
  static deserializeArray(json: string): FilterOtgVinylCatalogStyleRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgVinylCatalogStyleRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgVinylCatalogStyleRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgVinylCatalogStyleRequest instance to a plain object
   */
  static toObject(instance: FilterOtgVinylCatalogStyleRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgVinylCatalogStyleConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgVinylCatalogStyleRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgVinylCatalogStyleRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
